import { useState, type MouseEventHandler } from 'react';
import { AiOutlineZoomIn } from 'react-icons/ai';
import HtmlParser from './HtmlParser';
import { Spinner } from 'react-bootstrap';
import numberHumanizer from '@/helpers/numberHumanizer';
// نمایش دهنده آرایه ها در جدول
type ArrayRendererProps = {
  data?: unknown;
  onClick?: MouseEventHandler<SVGElement>;
};

const ArrayRenderer = ({ data, onClick }: ArrayRendererProps) => {
  const [opened, setOpened] = useState(false);
  const values = Array.isArray(data) ? data : [];

  return (
    <>
      {data && Array.isArray(data) && (
        <>
          {values.length > 1 && (
            <div className="d-flex align-items-center gap-1">
              <span
                onClick={() => {
                  setOpened(true);
                  setTimeout(() => {
                    setOpened(false);
                  }, 1500);
                }}
              >
                {!opened ? (
                  <AiOutlineZoomIn
                    onClick={onClick}
                    className="cursor-pointer fs-0"
                  />
                ) : (
                  <Spinner
                    animation="border"
                    style={{
                      width: '18px',
                      marginBottom: '-3px',
                      paddingLeft: '3px',
                      height: '18px'
                    }}
                  />
                )}
              </span>
              <span>{numberHumanizer(values.length)}</span>
            </div>
          )}
          {values.length == 1 && (
            <>
              {values[0] && (
                <HtmlParser html={decodeURIComponent(String(values[0]))} />
              )}
            </>
          )}
          {!data && null}
        </>
      )}
    </>
  );
};

export default ArrayRenderer;
